import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Cookies from "js-cookie";



// Admin Components
import Admin from "./components/Admin/Admin";
import ForgotPassword from "./components/Admin/ForgotPassword";
import Dashboard from "./components/dashboard/Dashboard";
import AddCategoryPage from "./components/dashboard/sections/AddCategoryPage";
// Admin Layout Components
import Sidebar from "./components/dashboard/Sidebar";
import CategoryManagementSection from "./components/dashboard/sections/CategoryManagement";
import ProductManagementSection from "./components/dashboard/sections/ProductManagementSection";
import AdminHeader from "./components/dashboard/Header";
import EditCategoryPage from "./components/dashboard/sections/EditCategoryPage";
import AddProductPage from "./components/dashboard/sections/AddProductPage";
import EditProductPage from "./components/dashboard/sections/EditProductPage";
import UserManagementSection from "./components/dashboard/sections/UserManagementSection";
import AddUserPage from "./components/dashboard/sections/AddUserPage";
import EditUserPage from "./components/dashboard/sections/EditUserPage";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./components/ProtactedRoute";
import Orders from "./components/dashboard/sections/Orders";


// Admin Layout Component
const AdminLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [user] = useState({ name: "Admin User", email: "admin@example.com" });
  const [notifications] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleNotificationRead = (id) => {
    // Handle notification read logic
  };

  const handleLogout = () => {
    // Handle logout logic
    window.location.href = '/admin';
  };

  return (
    <div className="admin-layout">

      <div className={`dashboard-main ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>

        <main className="admin-content d-flex">
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggle={toggleSidebar}
          />
          <div className={`admin-content-wrapper ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
            <AdminHeader
              user={user}
              notifications={notifications}
              onNotificationRead={handleNotificationRead}
              onLogout={handleLogout}
              onToggleSidebar={toggleSidebar}
              searchQuery={searchQuery}
              onSearchChange={setSearchQuery}
            />
            {children}
          </div>
        </main>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

// Main App Component
const App = () => {


  const location = useLocation();

  // Define admin routes
  const adminRoutes = [
    '/',
    '/forgotpassword',
    '/dashboard'
  ];

  // Check if current route starts with admin paths
  const isAdminRoute = adminRoutes.some(route =>
    location.pathname === route || location.pathname.startsWith('/dashboard')
  );

  return (

    <Routes>

      {/* Admin Routes without Layout (Login/Auth pages) */}
      <Route path="/" element={<Admin />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />

      {/* Dashboard Routes with Admin Layout */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/categories"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <CategoryManagementSection />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/add-category"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AddCategoryPage />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/edit-category/:id"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <EditCategoryPage />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/products"
        element={
          <protectedRoute>
            <AdminLayout>
              <ProductManagementSection />
            </AdminLayout>
          </protectedRoute>
        }
      />
      <Route
        path="/dashboard/add-product"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AddProductPage />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/edit-product/:id"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <EditProductPage />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/user"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <UserManagementSection />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/add-user"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AddUserPage />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/orders"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Orders />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/edit-user/:id"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <EditUserPage />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

    </Routes>


  );
};

export default App;